import React from 'react';
import { GiftIcon } from 'lucide-react';
import { IMAGES } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
export function BonusSection() {
  const bonuses = [{
    num: 1,
    title: 'Planner Professionale per Lezioni di Musica',
    desc: 'Template pronti da usare per organizzare le tue lezioni in modo semplice e professionale.',
    value: '12,99 €',
    img: IMAGES.TOMO_2
  }, {
    num: 2,
    title: 'Checklist della Lezione Perfetta',
    desc: 'Una checklist pratica per non dimenticare nulla e rendere ogni lezione più efficace.',
    value: '9,99 €',
    img: IMAGES.TOMO_3
  }, {
    num: 3,
    title: 'Mini Sistema di Fidelizzazione Studenti',
    desc: "Idee utili per migliorare l'esperienza dello studente e aumentare la continuità delle lezioni.",
    value: '14,99 €',
    img: IMAGES.TOMO_5
  }, {
    num: 4,
    title: 'Piano Rapido di Motivazione per Allievi Musicali',
    desc: 'Un bonus strategico per aiutarti a mantenere i tuoi studenti più coinvolti, costanti e soddisfatti.',
    value: '12,99 €',
    img: IMAGES.TOMO_1
  }];
  return <section className="py-16 md:py-24 px-4 bg-blue-900 text-white" data-id="element-20">
      <div className="max-w-5xl mx-auto" data-id="element-21">
        <div className="text-center mb-12" data-id="element-22">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-23">
            E in più, oggi ricevi anche 4 Bonus Gratuiti
          </h2>
          <p className="text-xl text-blue-200 max-w-3xl mx-auto" data-id="element-24">
            Strumenti extra pensati per aiutarti ad applicare tutto più
            velocemente e con risultati ancora migliori.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-25">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-white rounded-xl overflow-hidden flex flex-col sm:flex-row cursor-pointer hover:shadow-xl hover:shadow-blue-500/20 transition-all transform hover:-translate-y-1" onClick={scrollToOffer} data-id="element-26">
              {/* Left Side: Image */}
              <div className="w-full sm:w-2/5 bg-gray-50 relative flex items-center justify-center p-6 border-b sm:border-b-0 sm:border-r border-gray-100" data-id="element-27">
                <div className="absolute top-0 left-0 right-0 bg-red-600 text-white text-xs font-bold text-center py-1 uppercase tracking-wider z-10" data-id="element-28">
                  GRATIS per oggi
                </div>
                <img src={bonus.img} alt={`Bonus ${bonus.num}`} className="w-3/4 object-contain drop-shadow-lg mt-4" data-id="element-29" />
              </div>

              {/* Right Side: Content */}
              <div className="w-full sm:w-3/5 p-6 flex flex-col justify-center" data-id="element-30">
                <div className="flex items-center gap-2 mb-2" data-id="element-31">
                  <GiftIcon className="w-5 h-5 text-orange-500" data-id="element-32" />
                  <span className="text-orange-500 font-bold text-sm uppercase tracking-wider" data-id="element-33">
                    Bonus {bonus.num}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2 leading-tight" data-id="element-34">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4 flex-grow" data-id="element-35">
                  {bonus.desc}
                </p>
                <div className="flex items-center gap-2" data-id="element-36">
                  <span className="text-gray-400 line-through text-sm" data-id="element-37">
                    Valore: {bonus.value}
                  </span>
                  <span className="text-green-600 font-bold" data-id="element-38">
                    — Oggi GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-blue-800/50 border border-blue-700 rounded-xl p-6 text-center max-w-3xl mx-auto mb-10" data-id="element-39">
          <p className="text-xl md:text-2xl font-semibold" data-id="element-40">
            🎁 In totale riceverai 9 risorse complete per migliorare davvero il
            tuo modo di insegnare musica
          </p>
        </div>

        <div className="text-center" data-id="element-41">
          <button onClick={scrollToOffer} className="bg-orange-500 hover:bg-orange-600 text-white rounded-full py-5 px-10 font-bold text-xl shadow-lg shadow-orange-500/30 transition-all transform hover:scale-105" data-id="element-42">
            Voglio Tutto il Pacchetto
          </button>
        </div>
      </div>
    </section>;
}